import axiosInstance from "../libs/axiosInstance";

// Create a new faculty
export const createFaculty = async (facultyData) => {
  try {
    const response = await axiosInstance.post('/course_management/faculties/', facultyData);
    return response.data;
  } catch (error) {
    console.error('Error creating faculty:', error);
    throw error;
  }
};

// Get all faculties
export const getFaculties = async () => {
  try {
    const response = await axiosInstance.get('/course_management/faculties/');
    return response.data;
  } catch (error) {
    console.error('Error fetching faculties:', error);
    throw error;
  }
};

// Update a faculty
export const updateFaculty = async (facultyId, facultyData) => {
  try {
    const response = await axiosInstance.put(`/course_management/faculties/${facultyId}/`, facultyData);
    return response.data;
  } catch (error) {
    console.error('Error updating faculty:', error);
    throw error;
  }
};

// Delete a faculty
export const deleteFaculty = async (facultyId) => {
  try {
    await axiosInstance.delete(`/course_management/faculties/${facultyId}/`);
  } catch (error) {
    console.error('Error deleting faculty:', error);
    throw error;
  }
};
